import { QueryClient } from "@tanstack/react-query";
import { isAuthCredentialError } from "~/auth/authErrors";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Treat data as fresh for 60s after a successful fetch. `staleTime` never
      // triggers a refetch on its own — it only gates the triggers below — so
      // this collapses bursts of remounts/refetches during active navigation
      // without changing when data is *allowed* to refresh.
      staleTime: 60_000,
      // Don't refetch every active query when the tab regains focus. That
      // per-tab-switch burst is what stampeded the Identity Pool credential
      // endpoint (TooManyRequestsException). Freshness is covered by real-time
      // subscriptions (collaborative screens), refetch-on-mount (navigation),
      // post-mutation invalidation, and refetchOnReconnect below.
      refetchOnWindowFocus: false,
      // Keep reconnect on: it fires rarely (network drop / laptop wake), unlike
      // focus, and is the cheap way to refresh stale data after the machine
      // sleeps — exactly the case AuthSessionProvider guards for.
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        // Auth/credential errors are recovered by the GraphQL client's
        // refresh-and-retry shell. If one still surfaces here, recovery already
        // failed — blind-retrying only re-amplifies the credential-failure loop
        // (the ~3s NoSignedUser storm). Let it fail; configureAuthSession
        // handles a genuinely dead session via redirect to /login.
        if (isAuthCredentialError(error)) {
          return false;
        }
        return failureCount < 3;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
